import React, { useEffect, useState } from "react";
import CustomSearch from "../../../../../Components/CustomSearch";
import { ObjectValues } from "../../../../login";
import { LevelTypes } from "../../../../../store/slices/detailedMaster/detailedMasterSlice";
import { Box, Stack, Typography } from "@mui/material";
import Exam from "../../../../../Components/AllCards/Exam";
import CustomIconButton from "../../../../../Components/CustomIconButton";
import CustomContainedButton from "../../../../../Components/CustomContainedButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import apiRequest from "../../../../../request/apiRequest/apiRequest";
import { allApis } from "../../../../../request/config";
import { useAppDispatch } from "../../../../../hooks/storeHooks";
import { showSnack } from "../../../../../store/slices/constants";
import GlobalLoader from "../../../../../Components/GlobalLoader";
import ConfirmationDialog from "../../../../../Components/ConfirmationDialog";
import ConfirmationCloneTemplate from "../ConfirmationCloneTemplate";
import { getParentSmallPath } from "../../../../ContentMangements/Utils";
import { convertFirstUpper } from "../../../../../store/slices/constants/staticContents";
export interface cordsType {
  exam: boolean;
  goal: boolean;
  section: boolean;
  unit: boolean;
  topic: boolean;
  subtopic: boolean;
  cluster: boolean;
  question: boolean;
}
function ListWrapper({
  list,
  setFilters,
  idx,
  fields,
  level,
  parent_name,
  onClose,
  parent,
  setData,
  selectedData,
  child,
  filters,
  setTempSelected,
  cardsSelected,
  setCardsSelected,
  tempSelected,
  onSubmit,
}: {
  list: ObjectValues[];
  setFilters: any;
  parent_name?: string;
  filters: any;
  idx: any;
  fields: any;
  level: LevelTypes;
  onClose(): void;
  parent: any;
  setData(data: any): void;
  selectedData: ObjectValues;
  child?: any;
  setTempSelected: any;
  setCardsSelected: any;
  cardsSelected: any;
  tempSelected: any;
  onSubmit: any;
}) {
  const [tableData, setTableData] = useState<ObjectValues>({
    actual: [],
    copy: [],
  });

  const [lodaer, setloader] = useState(false);
  const [showFinalPreview, SetFinalPreview] = useState(false);

  const [rowData, setRowData] = React.useState<any>(tempSelected?.data ?? {});
  const dispatch = useAppDispatch();
  useEffect(() => {
    setTableData({
      actual: list,
      copy: list,
    });
  }, [list]);
  const onSubmitData = async (tempSelected: any) => {
    setloader(true);
    if (tempSelected) {
      const sections = selectedData.sections?.map((s: { id: any }) => s.id);
      const goals = selectedData.goals?.map((s: { id: any }) => s.id);
      const units = selectedData.units?.map((s: { id: any }) => s.id);
      const topics = selectedData.topics?.map((s: { id: any }) => s.id);
      const subtopics = selectedData.subtopics?.map((s: { id: any }) => s.id);
      const clusters = selectedData.clusters?.map((s: { id: any }) => s.id);
      const payload = parent
        ? level === "cluster"
          ? {
              ...parent,
              level: level,
              template_id: tempSelected.data.id,
              current_subtopic_id:
                level === "cluster" && filters.subtopic_id
                  ? filters.subtopic_id
                  : undefined,
            }
          : {
              ...parent,
              level: level,
              template_id: tempSelected.data.id,
              goal_ids: goals,
              section_ids: sections,
              unit_ids: units,
              topic_ids: topics,
              subtopic_ids: subtopics,
              cluster_ids: clusters,
              depth: cardsSelected.cluster
                ? "cluster"
                : cardsSelected.subtopic
                ? "subtopic"
                : cardsSelected.topic
                ? "topic"
                : cardsSelected.unit
                ? "unit"
                : cardsSelected.section
                ? "section"
                : cardsSelected.goal
                ? "goal"
                : "exam",
              [level]: {
                name:
                  level === "exam"
                    ? rowData
                      ? rowData.name
                      : `Copy of ${tempSelected.data.name}`
                    : rowData
                    ? rowData.name
                    : tempSelected.data.name,
              },
            }
        : {
            level: level,
            template_id: tempSelected.data.id,
            goal_ids: goals,
            section_ids: sections,
            unit_ids: units,
            topic_ids: topics,
            subtopic_ids: subtopics,
            cluster_ids: clusters,
            depth: cardsSelected.cluster
              ? "cluster"
              : cardsSelected.subtopic
              ? "subtopic"
              : cardsSelected.topic
              ? "topic"
              : cardsSelected.unit
              ? "unit"
              : cardsSelected.section
              ? "section"
              : cardsSelected.goal
              ? "goal"
              : "exam",
            [level]: {
              name: rowData
                ? rowData.name
                : `Copy of ${tempSelected.data.name}`,
            },
          };
      const statusResponse: any = await apiRequest({
        api: allApis.clone,
        payload: payload,
        method: "POST",
      });
      if (statusResponse && statusResponse.error) {
        dispatch(
          showSnack({
            open: true,
            severity: "error",
            message: statusResponse.msg,
          })
        );
      } else {
        dispatch(
          showSnack({
            open: true,
            severity: "success",
            message: `${level} cloned successfully`,
          })
        );

        onSubmit();
      }
      setloader(false);
      SetFinalPreview(false);
    }
  };
  return (
    <Stack width="100%" height="100%">
      {lodaer && <GlobalLoader open={true} />}
      <Box
        width="calc(100% - 10px)"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: "5px",
        }}
      >
        <Box m={"0 5px 5px"} width="calc(100% - 10px)">
          {level === fields[idx] ? (
            <Typography variant="subheading1" color="text.secondary">
              <b>Note:</b> Card with{" "}
              <span
                style={{
                  borderBottom: "2px dashed #519C66",
                  fontWeight: "bold",
                  color: "black",
                }}
              >
                GREEN BORDER
              </span>{" "}
              will be cloned along with all their child details when selected,
              If child items are not selected, they won't be copied.
            </Typography>
          ) : (
            <Typography
              variant="subheading1"
              color="text.secondary"
            >{`Select a ${fields[idx]} to see its details.`}</Typography>
          )}
        </Box>

        <Box sx={{ maxWidth: "400px" }}>
          {" "}
          <CustomSearch
            placeholder="Search by name"
            copyData={tableData.copy}
            fieldName={["name"]}
            filteredData={(array: ObjectValues[]) => {
              setTableData((prev) => {
                return { ...prev, actual: array };
              });
            }}
            onClear={() => {
              setTableData((prev) => {
                return { ...prev, actual: tableData.copy };
              });
            }}
          />
        </Box>
      </Box>
      <Stack
        width="100%"
        flexGrow={8}
        sx={{ overflowY: "auto" }}
        className="scrollBluePrimarythin"
      >
        <Stack
          width="100%"
          p="0 5px"
          boxSizing={"border-box"}
          // flexDirection="row"
          // flexWrap="wrap"
        >
          {tableData.actual.map((item: ObjectValues) => {
            const onChange =
              fields.indexOf(fields[idx]) >= fields.indexOf(level)
                ? () => {
                    if (fields[idx] === level) {
                      setTempSelected({
                        data: tempSelected?.data?.id === item.id ? null : item,
                      });
                      setRowData(
                        tempSelected?.data?.id === item.id
                          ? null
                          : {
                              ...item,
                              name:
                                level === "exam"
                                  ? `Copy of ${item.name}`
                                  : item.name,
                            }
                      );
                    }
                    setData((p: any) => {
                      if (fields[idx] === level) {
                        // Clear all lower hierarchy fields when selecting a new item at the current level
                        const hierarchy = [
                          "exam",
                          "goal",
                          "section",
                          "unit",
                          "topic",
                          "subtopic",
                          "cluster",
                        ];
                        const currentIdx = hierarchy.indexOf(level);
                        const clearedFields = hierarchy.slice(currentIdx + 1);

                        const clearedState = clearedFields.reduce(
                          (acc: Record<string, any>, field) => {
                            acc[`${field}s`] = [];
                            return acc;
                          },
                          {}
                        );

                        return {
                          ...p,
                          [level]:
                            p[level] && item.id === p[level]?.id ? "" : item,
                          ...clearedState,
                        };
                      } else {
                        const key = `${fields[idx]}s`;
                        const exists = p[key]?.some(
                          (i: any) => i.id === item.id
                        );
                        return exists
                          ? {
                              ...p,
                              [key]: p[key].filter(
                                (i: any) => i.id !== item.id
                              ),
                            }
                          : {
                              ...p,
                              [key]: p[key] ? [...p[key], item] : [item],
                            };
                      }
                    });
                    const hierarchy = [
                      "exam",
                      "goal",
                      "section",
                      "unit",
                      "topic",
                      "subtopic",
                      "cluster",
                    ];
                    const currentIdx = hierarchy.indexOf(level);
                    const clearedFields = hierarchy.slice(currentIdx + 1);

                    const clearedState = clearedFields.reduce(
                      (acc: Record<string, any>, field) => {
                        acc[`${field}`] = true;
                        return acc;
                      },
                      {}
                    );

                    setCardsSelected((prev: any) => ({
                      ...prev,
                      ...clearedState,
                    }));
                    // setCardsSelected(draftCords);
                  }
                : undefined;
            const onOpen = () => {
              setFilters((prev: any) => {
                const updated = { ...prev };
                switch (idx) {
                  case 0:
                    updated.exam = prev.exam === item.name ? "" : item.name;
                    updated.exam_id = prev.exam_id === item.id ? "" : item.id;
                    updated.goal = "";
                    updated.goal_id = "";
                    updated.section = "";
                    updated.section_id = "";
                    updated.unit = "";
                    updated.unit_id = "";
                    updated.topic = "";
                    updated.topic_id = "";
                    updated.subtopic = "";
                    updated.subtopic_id = "";
                    updated.cluster = "";
                    updated.cluster_id = "";
                    break;
                  case 1:
                    updated.goal = prev.goal === item.name ? "" : item.name;
                    updated.goal_id = prev.goal_id === item.id ? "" : item.id;
                    updated.section = "";
                    updated.section_id = "";
                    updated.unit = "";
                    updated.unit_id = "";
                    updated.topic = "";
                    updated.topic_id = "";
                    updated.subtopic = "";
                    updated.subtopic_id = "";
                    updated.cluster = "";
                    updated.cluster_id = "";
                    break;
                  case 2:
                    updated.section =
                      prev.section === item.name ? "" : item.name;
                    updated.section_id =
                      prev.section_id === item.id ? "" : item.id;
                    updated.unit = "";
                    updated.unit_id = "";
                    updated.topic = "";
                    updated.topic_id = "";
                    updated.subtopic = "";
                    updated.subtopic_id = "";
                    updated.cluster = "";
                    updated.cluster_id = "";
                    break;
                  case 3:
                    updated.unit = prev.unit === item.name ? "" : item.name;
                    updated.unit_id = prev.unit_id === item.id ? "" : item.id;
                    updated.topic = "";
                    updated.topic_id = "";
                    updated.subtopic = "";
                    updated.subtopic_id = "";
                    updated.cluster = "";
                    updated.cluster_id = "";
                    break;
                  case 4:
                    updated.topic = prev.topic === item.name ? "" : item.name;
                    updated.topic_id = prev.topic_id === item.id ? "" : item.id;
                    updated.subtopic = "";
                    updated.subtopic_id = "";
                    updated.cluster = "";
                    updated.cluster_id = "";
                    break;
                  case 5:
                    updated.subtopic =
                      prev.subtopic === item.name ? "" : item.name;
                    updated.subtopic_id =
                      prev.subtopic_id === item.id ? "" : item.id;
                    updated.cluster = "";
                    updated.cluster_id = "";
                    break;
                  case 6:
                    updated.cluster =
                      prev.cluster === item.name ? "" : item.name;
                    updated.cluster_id =
                      prev.cluster_id === item.id ? "" : item.id;
                    break;
                  default:
                    break;
                }
                return { ...updated };
              });
            };
            return (
              <Box sx={{ width: "calc(100% - 10px)", margin: "5px" }}>
                {(() => {
                  const cardProps = {
                    data: item,
                    onclick: onChange,
                    setCardsSelected: (p: Partial<cordsType>) => {
                      setCardsSelected((prev: any) => ({ ...prev, ...p }));
                    },
                    selected: selectedData[`${fields[idx]}s`]
                      ? selectedData[`${fields[idx]}s`].find(
                          (s: { id: any }) => s.id === item.id
                        )
                      : selectedData[`${fields[idx]}`]
                      ? selectedData[`${fields[idx]}`].id === item.id
                      : false,
                    cardsSelected,
                    tempSelected,
                    child: child(idx) ? (
                      filters[`${fields[idx]}_id`] === item.id ? (
                        <Box sx={{ p: "16px", boxSizing: "border-box" }}>
                          {child(idx, filters)}
                        </Box>
                      ) : (
                        ""
                      )
                    ) : undefined,
                    onOpen: fields[idx] === "cluster" ? undefined : onOpen,
                    selectedData:selectedData
                  };

                  // const cardComponents: Record<string, React.ElementType> = {
                  //   exam: Exam,
                  //   goal: Goal,
                  //   section: Section,
                  //   unit: Unit,
                  //   topic: Topic,
                  //   subtopic: Subtopic,
                  //   cluster: Cluster,
                  // };
                  const CardComponent = Exam;
                  //  cardComponents[fields[idx]];
                  return <CardComponent {...cardProps} />;
                })()}
              </Box>
            );
          })}
        </Stack>
      </Stack>
      {/* footer */}
      {fields[idx] === "exam" && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "end",
            p: "5px",
            boxSizing: "border-box",
            gap: "10px",
          }}
        >
          <CustomIconButton
            key="cancel"
            variant="outlined"
            content="cancel"
            sx={{ minWidth: "180px" }}
            onClick={() => {
              onClose();
            }}
          />
          {showFinalPreview && tempSelected.data && (
            <ConfirmationDialog
              sx={{
                "& .MuiDialog-paper":
                  level === "exam"
                    ? {
                        margin: "0",
                        minHeight: "100dvh",
                        minWidth: "100%",
                        borderRadius: 0,
                      }
                    : {},
              }}
              onClose={() => {
                SetFinalPreview(false);
              }}
              open={true}
              title={`${convertFirstUpper(level)} ${
                tempSelected?.data?.name
              } will be cloned ${
                parent_name
                  ? `under ${getParentSmallPath(level)} ${parent_name}`
                  : ""
              }`}
              content={
                <>
                  {lodaer && <GlobalLoader open={true} />}
                  <ConfirmationCloneTemplate
                    tempSelected={tempSelected}
                    selectedData={selectedData}
                    setRowData={setRowData}
                    rowData={rowData}
                    showForm={level === "exam"}
                    level={level}
                    cardsSelected={cardsSelected}
                  />
                </>
              }
              onSubmit={() => {
                onSubmitData(tempSelected);
              }}
            />
          )}
          <CustomContainedButton
            otherProps={{
              disabled: tempSelected === null || !tempSelected.data,
              onClick: () => {
                SetFinalPreview(true);
                // onSubmitData(tempSelected);
              },
              sx: { minWidth: "fit-content" },
            }}
            icon="Proceed with selection"
            content={<ArrowForwardIcon sx={{ height: "16px" }} />}
          />
        </Box>
      )}
    </Stack>
  );
}

export default ListWrapper;
